export default "__VITE_ASSET__BUHx0C4s__"